import type { IEppoAssignmentParams } from './types';

import { buildSubjectAttributes } from './subject';
import { getEppoClient } from './client';

export const getStringSafe = ({ flag, attrs, def }: IEppoAssignmentParams<string>): string => {
    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return c && subject ? c.getStringAssignment(flag, subject, def) : def;
};

export const getJsonSafe = <T extends Record<string, unknown>>({ flag, attrs, def }: IEppoAssignmentParams<T>): T => {
    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return (c && subject ? c.getJSONAssignment(flag, subject, def) : def) as T;
};

export const getBooleanSafe = ({ flag, attrs, def }: IEppoAssignmentParams<boolean>): boolean => {
    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return c && subject ? c.getBooleanAssignment(flag, subject, def) : def;
};
